import { render, staticRenderFns } from "./Econmic.vue?vue&type=template&id=2b4d5932&"
import script from "./Econmic.vue?vue&type=script&lang=js&"
export * from "./Econmic.vue?vue&type=script&lang=js&"
import style0 from "./Econmic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports